import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteExhibitionOptions {
  readonly onSuccess?: () => void;
}

/** 기획전 행과 상품 연결·S3 대표 이미지를 함께 지운다. 확인창은 호출부가 띄운다. */
export const useDeleteExhibition = ({ onSuccess }: UseDeleteExhibitionOptions = {}) => {
  const mutation = trpc.productManagement.exhibitions.delete.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    deleteExhibition: (id: string) => mutation.mutate({ id }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 목록의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
